<template>
  <!-- style="min-width: 1200px;" -->
  <div class="citySummit">
    <b-container>
      <little-bar :current="current" :navlist="navlist" copyright="forum">
        <template v-slot:right-nav>
          <div class="right">
            <div class="term-btn">
              <div class="text">
                <div class="yearTxt">年份：{{ yearsel }}</div>
                <b-icon class="arrow" icon="chevron-down"></b-icon>
              </div>
              <div class="drop-down">
                <div
                  class="drop-item"
                  v-for="(value, index) in dateDrop"
                  :key="index"
                  @click="yearsel = value"
                >
                  {{ value }}
                </div>
              </div>
            </div>
          </div>
        </template>
      </little-bar>
      <b-row style="margin-top: 1rem">
        <template v-for="(item, index) in dataList">
          <b-col :key="index" md="4" cols="6">
            <router-link
              :to="`/forum/project/citySummit/selList?firId=${item.id}&index=0`"
            >
              <div class="img-wrap img-hovor">
                <img width="100%" height="100%" :src="item.titleImg" />
              </div>
              <div
                style="
                  width: 90%;
                  margin: auto;
                  text-align: center;
                  line-height: 2rem;
                "
              >
                <p
                  :style="{
                    color: '#4a4a4a',
                  }"
                  class="name"
                >
                  {{ item.name }}
                </p>
                <p
                  :style="{
                    color: '#999999',
                  }"
                  class="dateTime"
                >
                  {{ item.dateTime }}
                </p>
              </div>
            </router-link>
          </b-col>
        </template>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      current: 0,
      currentName: "",
      yearsel: "ALL",
      navlist: [
        {
          text: this.$t("lang.cityMeeting"),
          link: "/forum/project/citySummit",
        },
      ],
      dateDrop: [],

      dataList: [],
    };
  },
  created() {
    this.getYear();
    this.getFirList();
  },
  mounted() {},
  watch: {
    $route: {
      handler(to) {
        this.year = to.query.year;
        this.getFirList();
      },
      immediate: true,
      deep: true,
    },
    yearsel(val) {
      this.$router.push({
        path: this.$route.fullPath,
        query: {
          year: this.yearsel == "ALL" ? "" : this.yearsel,
        },
      });
    },
  },
  methods: {
    showDropDown() {
      this.show = !this.show;
    },
    getFirList() {
      this.dataList = [];
      this.$forumApi.MeetingFirList({ year: this.year }).then((res) => {
        if (res.code == 200) {
          this.dataList = res.data;
        }
      });
    },
    getYear() {
      var nowDate = new Date();
      let isyear = nowDate.getFullYear();
      //计算获取最近六年
      for (let index = 1; index <= 8; index++) {
        this.dateDrop.push(isyear - 8 + index);
      }
      this.dateDrop.reverse();
      this.dateDrop.unshift("ALL");
    },
  },
};
</script>
<style lang="scss" scoped>
.term-btn {
  margin-left: 1rem;
  cursor: pointer;

  .text {
    display: flex;
    align-items: center;
  }

  .drop-down {
    display: none;
  }
}

.term-btn:hover {
  .drop-down {
    position: relative;
    display: block;
    background-color: #f2f2f2;
    z-index: 99;
    text-align: center;

    .drop-item:hover {
      color: $forum-theme-blue;
      cursor: pointer;
    }
  }
}

.citySummit ::v-deep {
  min-height: 70vh;
  .col-md-4,
  .col-6 {
    padding: 0;
  }
  .drop-down {
    height: 18rem!important;
  }
  .drop-item {
    height: 3rem;
    color: #666666;
  }
  .img-wrap {
    width: 97%;
    height: 16.2rem;
    margin: 1rem auto;
    border-radius: 10px;
    img:hover {
      transform: scale(1.05, 1.05);
      transition: transform 0.8s cubic-bezier(0.215, 0.61, 0.355, 1),
        opacity 0.36s cubic-bezier(0.215, 0.61, 0.355, 1);
    }
  }
  .name {
    font-size: 16px;
    height: 2.5rem;
  }
  a {
    text-decoration: none;
    cursor: pointer;
  }

  .title {
    font-size: 1.5rem;
  }
  .little-nav {
    margin: 0rem !important;
  }
  .right {
    display: flex;
    flex: 1;
    justify-content: flex-end;
    position: absolute;
    right: 0px;
    font-size: 13px;
    color: black;

    .drop-down {
      height: 13rem;
      overflow-y: auto;
    }
  }
}
@media (min-width: 992px) {
  // .city {
  //   min-width: 1200px;
  // }
  .yearTxt {
    margin-right: 1.5rem;
    font-size: 14px;
  }
  .arrow {
    font-size: 12px;
  }
  .container {
    padding-right: 0px;
    padding-left: 0px;
  }
}
@media (max-width: 768px) {
  .citySummit ::v-deep {
    .img-wrap {
      width: 86%;
      height: 7.6rem;
      margin: 1rem auto;
      border-radius: 6px;
    }
    .name {
      font-size: 13px;
      height: 4rem;
    }
    .container {
      padding-right: 25px;
      padding-left: 25px;
    }
    .yearTxt {
      margin-right: 1.5rem;
      font-size: 12px;
    }
    .arrow {
      font-size: 10px;
    }
  }
}
</style>